export const MAIN_URL = "https://gimc.by";

export const PORT = ":8080/";
export const PORT_FOR_AUTH = ":8081/";
export const PORT_FOR_REPORT = ":8082/";
export const PORT_FOR_TRAINING = ":8083/";
export const PORT_FOR_INTEGRATION = ":8084/";

export const API_GET_BOATS_LIST_SEARCH = "boats/search";
export const API_GET_PAGINATION_BOATS_LIST_SEARCH = "boats/searchPageable?";
export const API_GET_BOAT_INFO_CARD = "boats/getBoatCard/";
export const API_GET_BOAT_INFO_SPEC_MARKS = "boats/getBoatCardSpecmarks/";
export const API_GET_BOAT_INFO_ARRESTS = "boats/getBoatArrests/";
export const API_GET_BOAT_CARD_FOR_MODIF = "boatCardModif/getBoatCardAsBoatModif/";
export const API_GET_STATEMENT_MODIF_INFO = "boatCardModif/getBoatCardModif/";
export const API_ADD_CHANGE_INFORMATION_CARD = "boatCardModif/addStatement/";
export const API_GET_LICENSE_INFO_FOR_MODAL = "boats/license/search/";

export const API_DOWNLOAD_FILE_MODIF = "boatCardModif/download/";
export const API_ACCEPT_BOAT_MODIF = "boatCardModif/register/";
export const API_DECLINE_BOAT_MODIF = "boatCardModif/refuseApp/";
export const API_CHECK_ENGINES_MODIF = "boatCardModif/checkEngineVin";
export const API_CHECK_ENGINES_STATIC_MODIF = "boatCardModif/check/engnum";

export const API_GET_LICENSE_LIST_SEARCH = "boats/license/searchPageable?";
export const API_GET_LICENSE_INFO_CARD = "boats/license/drivingLicense/";
export const API_GET_LICENSE_ADD_INFO_CARD = "boats/license/drivingLicenseAdd/";
export const API_EDIT_LICENSE_CARD = "boats/license/drivingLicense/edit/";
export const API_PRINT_LICENSE_CARD = "boats/license/print/pattern/";

export const API_GET_BASES_BUILDING_LIST_SEARCH = "bases/searchPageable?";
export const API_EDIT_BASES_BUILDING = "bases/updateBoatParking/";
export const API_ADD_BASES_BUILDING = "bases/addBoatParking";
export const API_ADD_BASES_ARCHIVE = "bases/archive/";

export const API_GET_GIMS_SECTIONS = "static/info/gimsSections";
export const API_GET_OWNER_TYPE = "static/info/personTypes";
export const API_GET_NSI_CHECK_STATUS = "static/info/nsiCheckStatus";
export const API_GET_STATUS_ISSUANCE_CERTIFICATES = "static/info/boatDlAppStatus";

export const API_GET_LICENSE_INFO_FROM_LIBS_OBLAST = "directory/oblast/";
export const API_GET_LICENSE_INFO_FROM_LIBS_RAYON = "directory/rayon/";
export const API_GET_LICENSE_INFO_FROM_LIBS_GOROD = "directory/gorod/";

export const API_ADD_NEW_SPECIAL_MARK = "boats/license/addBoatDrivingLicenseSpecmarks/";
export const API_ADD_NEW_CONF_MARK = "boats/license/addBoatDrivingLicenseConf/";

export const API_GET_USERS_LIBRARY = "static/info/gimsUsers";
export const API_GET_ATE_LIBRARY = "static/info/gimsSections";
export const API_GET_APP_REG_STATUS_LIBRARY = "static/info/boatCardStatus";
export const API_GET_DICTIONARY_RAYON_FOR_OBL = "directory/getRayonByOblast/";
export const API_GET_AUDIT_OBJECT = "audit/getAuditObject";
export const API_GET_DICTIONARY_GOROD_FOR_RAYON = "directory/getGorodByRayon/";
export const API_GET_DICTIONARY_SECTION_FOR_RAYON = "directory/getGimsSectionDistrictByRayon/";
export const API_LICENSE_CANCELLATION = "boats/license/changeLicenseDateEnd/";
export const API_GET_TRAINING_PROGRAM_LIBRARY = "directories/trainingProgs";
export const API_GET_VALID_ZONES_LIBRARY = "static/info/boatDlValidZones";
export const API_GET_VALID_TYPES_LIBRARY = "static/info/boatDlValidTypes";
export const API_GET_GOROD_BY_OBL = "directory/ateObject";

export const API_ADD_NEW_BOAT_DEAL = "boats/saveBoatDeals/";
export const API_ADD_NEW_BOAT_SPEC_MARK = "boats/addBoatCardSpecmarks/";
export const API_EDIT_BOAT_SPEC_MARK = "boats/updateBoatCardSpecmarks/";
export const API_ADD_BOAT_INFO_ARRESTS = "boats/saveBoatArrests/";
export const API_EDIT_BOAT_INFO_ARRESTS = "boats/editBoatArrests/";
export const API_ADD_BOAT_INFO_DOCS = "boats/file/uploadfile";
export const API_ADD_BOAT_INFO_DOCS_DOWNLOAD = "boats/file/download/attachment/";
export const API_DELETE_BOAT_INFO_DOCS = "boats/file/";
export const API_UPDATE_BOAT_INFO_API = "boats/update/";

export const API_GET_BOATS_REG_LIST_SEARCH = "boatCardApp/searchPageable?";

export const API_GET_BOATS_REG_INFO = "boatCardApp/getBoatCardApp/";
export const API_GET_BOATS_REG_ENG = "boatCardApp/getEngines/";
export const API_GET_BOATS_REG_DEALS = "boatCardApp/getDeals/";
export const API_GET_BOATS_REG_SPEC_MARKS = "boatCardApp/getSpecMarks/";
export const API_GET_BOATS_DECISION_INFO = "boatCardApp/confirmReg/";
export const API_ACCEPT_BOAT_REGISTRATION = "boatCardApp/registerBoat/";
export const API_DECLINE_BOAT_REGISTRATION = "boatCardApp/refuseApp/";

export const API_REG_INFORM_CHANGE = "boatCardModif/searchPageable?";
export const API_REG_INFORM_CHANGE_BOAT_CARD = "boatCardModif/searchBoatCard?";

export const API_ADD_NEW_ENGINE_CHECK = "boatCardApp/checkEngineVin";
export const API_ADD_NEW_ENGINE_CHECK_STATIC = "boatCardApp/check/static/engnum/";
export const API_GET_BOAT_TYPES = "static/info/boatTypes";
export const API_GET_BOAT_VID = "static/info/boatVid";
export const API_GET_BOAT_BODY = "static/info/boatBody";
export const API_GET_SA_CATEGORY = "static/info/saCategory";
export const API_GET_RAYONS_BY_GOROD_ID = "directory/getRayonByGorodId/";
export const API_PRINT_STATEMENT_BOAT = "boatCardApp/print/report/";

export const API_ADD_NEW_STATEMENT = "boatCardApp/addStatement";
export const API_ADD_STATEMENT_FILE_DOWNLOAD = "boatCardApp/download/";
export const API_CHECK_POSSIBILITY_SAVING_APP = "boatCardApp/checkBoatCardApp";

//NSI
export const API_DOWNLOAD_LEGISLATION_FILE = "nsi/downloadFile/";

export const API_GET_CLASSIFICATION_BOATS = "nsi/classificationBoats";

export const API_GET_LEGISLATION_INFO = "static/info/infLegislation";
export const API_ADD_LEGISLATION_INFO = "nsi/addInfLegislation";
export const API_EDIT_LEGISLATION_INFO = "nsi/changeInfLegislation/";
export const API_DELETE_LEGISLATION_INFO = "nsi/deleteInfLegislation/";

export const API_GET_FORMS_INFO = "static/info/insForms";
export const API_ADD_FORMS_INFO = "nsi/addInfForms";
export const API_EDIT_FORMS_INFO = "nsi/changeInfForms/";
export const API_DELETE_FORMS_INFO = "nsi/deleteInfForms/";

export const API_GET_PAID_PROC_INFO = "nsi/infPaidProceduresView";
export const API_ADD_PAID_PROC_INFO = "nsi/addInfPaidProcedures";
export const API_EDIT_PAID_PROC_INFO = "nsi/changeInfPaidProcedures/";
export const API_DELETE_PAID_PROC_INFO = "nsi/deleteInfPaidProcedures/";

export const API_GET_REQUISITES_INFO = "nsi/infRequisitesView";
export const API_ADD_REQUISITES_CHAPTER = "nsi/addChapter";
export const API_EDIT_REQUISITES_CHAPTER = "nsi/changeChapter/";
export const API_DELETE_REQUISITES_CHAPTER = "nsi/deleteChapter/";
export const API_ADD_REQUISITES_LINE = "nsi/addLine/";
export const API_EDIT_REQUISITES_LINE = "nsi/changeLine/";
export const API_DELETE_REQUISITES_LINE = "nsi/deleteLine/";

export const API_GET_CONTACTS_INFO = "static/info/gimsDepartament";
// "static/info/gimsSectionsOrderByName"
export const API_GET_DEPARTMENT_INFO = "nsi/contactsByDepartment/";
export const API_GET_SECTION_INFO = "nsi/contacts/";

export const API_GET_ADMIN_PROC = "static/info/nsiAp";
export const API_ADD_ADMIN_PROC = "nsi/addNsiAp";
export const API_EDIT_ADMIN_PROC = "nsi/changeNsiAp/";
export const API_DELETE_ADMIN_PROC = "nsi/deleteNsiAp/";
//NSI

//DuplicateShipsTicket

export const API_DUP_SHIP_TICKET_DATA = "boatCardAppDup/searchAppPageable?";
export const API_GET_BOAT_CARD_FOR_DUPLICATE = "boatCardAppDup/getBoatCardForBoatCardDup/";
export const API_ADD_NEW_APP_DUPL = "boatCardAppDup/addStatement/";
export const API_ADD_NEW_APP_DUPL_CHECK = "boatCardAppDup/checkApp/";
export const API_GET_APP_INFO_DUPLICATE = "boatCardAppDup/getBoatCardDupSite/";
export const API_GET_DUPLICATE_DECISION_INFO = "boatCardAppDup/confirmReg/";
export const API_ACCEPT_DUPLICATE = "boatCardAppDup/saveBoatCardAppDup/";
export const API_DECLINE_DUPLICATE = "boatCardAppDup/refuseApp/";
export const API_GET_DUPLICATE_BOAT_CARDS = "boatCardAppDup/searchBoatCard?";
export const API_PRINT_DUPL_SHIPS_TICKET = "boatCardAppDup/print/report/";

// export const API_DUP_SHIP_TICKET_BOAT_CARD = "boatCardAppDup/searchBoatCard";
// export const API_DUP_SH
// boatCardAppDup/addStatement/

export const API_GET_SHIPS_TICKET_DATA = "issuanceBoatTicket/searchTicketPageable?";
export const API_GET_SHIPS_TICKET_DECISION_INFO = "issuanceBoatTicket/confirmReg";
export const API_ACCEPT_SHIPS_TICKET = "issuanceBoatTicket/saveBoatCardAppDup";
export const API_DECLINE_SHIPS_TICKET = "issuanceBoatTicket/refuseApp";
export const API_PRINT_SHIPS_TICKET = "ticket/print";

export const API_GET_DATA_PROVISION_INFORMATION = "boatInfoApp/searchAppPageable?";
export const API_ADD_STATEMENT_PROVISION_INFORMATION = "boatInfoApp/addStatement";
export const API_GET_STATEMENT_PROVISION_INFORMATION = "boatInfoApp/getBoatInfo/";
export const API_DOWNLOAD_FILE_PROVISION_INFO = "boatInfoApp/download/";
export const API_DOWNLOAD_FILEREPORT_PROVISION_INFO = "boatInfoApp/report/";
export const API_DOWNLOAD_STATEMENT_PROVISIONINFORMATION = "boatInfoApp/print/report/";
export const API_GET_INSPECTOR_WORK_STAT = "repinspector/screen/report";
export const API_GET_WEEKLY_REPORT = "weeklyreport/reportWeeklyPdf";
export const API_GET_TRAFFIC_ACCIDENTS_REPORT = "accidentreport/reportTransportAccidentExcelAndPdf";
export const API_GET_CERTIFICATE_REPORT = "repdl/reportDIPdfAndExcel";
export const API_GET_QUARTERLY_REPORT = "repquarter/quarterReport";
export const API_GET_FIVEYEARS_GRAPH_REPORT = "graph/downloadDocReport";
export const API_GET_FIVEQUARTER_GRAPH_REPORT = "quarter/dynamic/graph/download";
export const API_GET_MONTH_GRAPH_REPORT = "graph/downloadDocReportGraph2";
export const API_GET_SHORT_REPORT = "shortreport/1";
export const API_GET_TRAINING_REPORT = "repTraining/report";
export const API_GET_PAID_SERVICES_REPORT = "report/print";
export const API_PRINT_INSPECTOR_WORK_STAT = "repinspector/report/excel?";

export const API_GET_TRANSPORT_ACCIDENT_LIST_SEARCH_PAGINATION = "boatincidents/searchPageable?";
export const API_GET_TRANSPORT_ACCIDENT_LIST_SEARCH = "boatincidents/search";
export const API_FIND_BOAT_INFO_BY_REGNUM = "boatincidents/getByRegNum/";
export const API_FIND_BOAT_INFO_BY_ID = "boatincidents/getByRegNum/";
export const API_SAVE_TRANSPORT_ACCIDENT_MAIN_INFO_ADD = "boatincidents/saveIncident/add";
export const API_SAVE_TRANSPORT_ACCIDENT_MAIN_INFO_EDIT = "boatincidents/saveIncident/edit";
export const API_SAVE_TRANSPORT_ACCIDENT_MAIN_INFO_FORM = "boatincidents/saveIncident/form";
export const API_TERMINATION_CASE = "boatincidents/stop/";
export const API_DELETE_TRANSPORT_ACCIDENT_VICTIMS_INFO = "boatincidents/deleteVictims/";
export const API_DELETE_TRANSPORT_ACCIDENT_CAUSERS_INFO = "boatincidents/deleteCausers/";
export const API_ADD_TRANSPORT_ACCIDENT_FILE = "incident/file/uploadfile";
export const API_GET_TRANSPORT_ACCIDENT_FILELIST = "incident/file/filelist/";
export const API_DOWNLOAD_TRANSPORT_ACCIDENT_FILE = "incident/file/download/";
export const API_DELETE_TRANSPORT_ACCIDENT_FILE = "incident/file/delete/";

export const API_GET_TECH_EXAM_LIST_SEARCH = "boatToApp/searchAppPageable?";
export const API_GET_BOAT_CARD_FOR_TECH_EXAM = "boatToApp/getBoatCardForBoatCardToApp/";
export const API_ADD_STATEMENT_TECH_EXAM = "boatToApp/addStatement/";
export const API_GET_APP_DATA_FOR_EDIT_TECH_EXAM = "boatToApp/boatToAppSiteView/";
export const API_REPEAT_STATEMENT_TECH_EXAM = "boatToApp/resultTo/";
export const API_DOWNLOAD_FILE_TECH_EXAM = "boatToApp/download/";
export const API_GET_BOARDS_CARDS_TECH_EXAM = "boatToApp/searchBoatCard?";
export const API_PRINT_TECH_EXAM = "boatToApp/print/report/";
export const API_CHECK_POSSIBILITY_SAVING_APP_TECH_EXAM = "boatToApp/check/statement/";

export const API_GET_DATA_APPLICATION_TRAINING = "trainingApp/searchPageable?";
export const API_ADD_APPLICATION_TRAINING = "trainingApp/addStatement";
export const API_GET_APPLICATION_TRAINING = "trainingApp/getTrainingApp/";
export const API_EDIT_APPLICATION_TRAINING = "trainingApp/editStatement/";
export const API_DOWNLOAD_PHOTO_APPLICATION_TRAINING = "trainingApp/download/";
export const API_PRINT_APPLICATION_TRAINING = "trainingApp/print/pattern";

export const API_GET_DATA_EXPULSION_ORDER = "trainingOrders/searchPageable?";
export const API_GET_DATA_EXPULSION_ORDER_LOGBOOK = "trainingLog/searchPageable?";
export const API_GET_ALL_DATA_EXPULSION_ORDER_LOGBOOK = "trainingLog/search";
export const API_GET_EXPULSION_ORDER_FILE = "trainingLog/printPdf";
export const API_SAVE_EXPULSION_ORDER = "trainingOrders/saveOrder";
export const API_GET_EXPULSION_ORDER = "trainingOrders/getTrainingOrders";
export const API_GET_DATA_SEARCH_LISTENER = "trainingOrders/searchListener";

export const API_GET_DATA_RECORD_TRAINED_USERS_LOGBOOK = "trainingRegister/searchLog";
export const API_GET_DATA_RECORD_TRAINED_USERS_LOGBOOK_PAGINATION = "trainingRegister/searchLogPageable?";
export const API_GET_RECORD_TRAINED_USERS_LOGBOOK_FILE = "trainingRegister/printPdf";

export const API_GET_DATA_RECORD_TRAINED_USERS = "trainingRegister/searchPageable?";
export const API_SAVE_RECORD_TRAINED_USERS = "trainingRegister/saveRegister";
export const API_GET_RECORD_TRAINED_USER = "trainingRegister/viewRegister/";
export const API_SAVE_CHANGE_RECORD_TRAINED_USER = "trainingRegister/editRegister/";

export const API_GET_DATA_APP_KNOWLEDGE_VERIFICATION = "trainingCheckApp/searchPageable?";
export const API_GET_DATA_BY_INPUT_INFO_KNOW_VERIF =
  "trainingCheckApp/getDataBySurnameAndNameAndBirthDateAndProgramId/";
export const API_ADD_APP_KNOWLEDGE_VERIFICATION = "trainingCheckApp/addStatement";
export const API_GET_APP_KNOWLEDGE_VERIFICATION = "trainingCheckApp/getTrainingCheckApp/";
export const API_EDIT_APP_KNOWLEDGE_VERIFICATION = "trainingCheckApp/editStatement/";
export const API_DOWNLOAD_PHOTO_APP_KNOWLEDGE_VERIFICATION = "trainingCheckApp/download/";
export const API_PRINT_APP_KNOWLEDGE_VERIFICATION = "trainingCheckApp/print/pattern";

export const API_GET_ISSUING_CERTIFICATES_SEARCH = "boats/license/search/appissuance/pageable?";
export const API_GET_ISSUING_CERTIFICATES_APPLICANT_SEARCH = "boats/license/search/appApplicant?";
export const API_GET_APPLICANT_INFO_BY_ID = "boats/license/getAppApplicantById/";
export const API_SAVE_ISSUING_CERTIFICATE_APP = "boats/license/saveIssuanceApp";
export const API_SAVE_ISSUING_CERTIFICATE_APP_CHECK = "boats/license/checkApp";
export const API_GET_ISSUING_APP_BY_ID = "boats/license/getIssuanceAppById/";
export const API_ISSUE_CERTIFICATE_BY_ID = "boats/license/completeIssuanceApp/";
export const API_GET_EXCHANGE_CERTIFICATES_SEARCH = "boatDrivingLicenseExchange/searchPageable?";
export const API_GET_CERTIFICATE_INFO_BY_NUM_EXCHANGE = "boatDrivingLicenseExchange/searchByLicenseNum";
// boats/license/search/BoatDrivingLicenseExchange/license/
export const API_SAVE_EXCHANGE_CERTIFICATES_APP = "boatDrivingLicenseExchange/saveApp";
export const API_SAVE_EXCHANGE_CERTIFICATES_APP_CHECK = "boatDrivingLicenseExchange/checkApp";
export const API_GET_EXCHANGE_APP_BY_ID = "boatDrivingLicenseExchange/viewApp/";
export const API_PRINT_EXCHANGE_CERTIFICATE_APP = "boatDrivingLicenseExchange/print/pattern/";

export const API_GET_DUPLICATE_CERTIFICATES_SEARCH = "boatDrivingLicenseDuplicate/searchPageable?";
export const API_SAVE_DUPLICATE_CERTIFICATES_APP = "boatDrivingLicenseDuplicate/saveApp";
export const API_SAVE_DUPLICATE_CERTIFICATES_APP_CHECK = "boatDrivingLicenseDuplicate/checkApp";
export const API_GET_CERTIFICATE_INFO_BY_NUM_DUPLICATE = "boatDrivingLicenseDuplicate/searchByLicenseNum/";
export const API_GET_DUPLICATE_APP_BY_ID = "boatDrivingLicenseDuplicate/viewApp/";
export const API_GET_CERTIFICATE_INFO_BY_PERS_NUM_DUPLICATE =
  "boatDrivingLicenseDuplicate/searchByLicenseNum/";
export const API_PRINT_DUPLICATE_CERTIFICATE_APP = "boatDrivingLicenseDuplicate/print/pattern/";

export const API_GET_DATA_KNOWELEDGE_TEST_RECORD = "trainingCheck/examCheckPageable?";
export const API_GET_PEOPLE_DATA_KNOWELEDGE_TEST_RECORD = "trainingCheck/search";
export const API_SAVE_KNOWELEDGE_TEST_RECORD = "trainingCheck/saveTrainingCheck";
export const API_GET_DATA_FOR_EDIT_KNOWELEDGE_TEST_RECORD = "trainingCheck/dataForEdit";
export const API_SAVE_EDIT_KNOWELEDGE_TEST_RECORD = "trainingCheck/editExamCheck";
export const API_GET_PROTOCOLS_FOR_PEOPLE_KNOWELEDGE_TEST_RECORD = "trainingCheck/getProtocols/";
export const API_PRINT_PROTOCOL_FOR_PEOPLE_KNOWELEDGE_TEST_RECORD = "trainingCheck/reportDoc";

////////////////////ToDo тут под вопросом нужен ли токен
export const API_AUTHORIZATION_LOGIN = "api/auth/login";
export const API_FIRST_LOGIN = "api/auth/updatePassword";
export const API_REFRESH_ACCESS_TOKEN = "api/auth/token";
export const API_REFRESH_REFRESH_TOKEN = "api/auth/refresh";
///////////////////

export const API_GET_SEARCH_DATA_PRINT_CERTIFICATES = "printCertificates/searchCertificatesPageable?";
export const API_GET_DATA_FOR_CARD_PRINT_CERTIFICATES = "printCertificates/previewCertificates/";
export const API_SAVE_DATA_AFTER_VIEW_CARD_PRINT_CERTIFICATES = "printCertificates/previewCertificates/save/";
export const API_GET_FILE_FOR_PRINT_CARD_PRINT_CERTIFICATES = "printCertificates/printCertificate";
export const API_SAVE_DATA_AFTER_EDIT_LICENSENUM_CARD_PRINT_CERTIFICATES = "printCertificates/setNumber";

export const API_INSPECTION_TECHNICAL_CONDITION_BASES = "bases/searchPageable?";
export const API_INSPECTION_TECHNICAL_CONDITION_BASES_ALL = "bases/search";

export const API_UPLOAD_FILE_BASES = "bases/uploadfile/";
export const API_DOWNLOAD_EXAMINATION_RESULT_FILE = "bases/download/";
export const API_ADD_REVESION_BASES = "bases/addRecordAboutCheck/";

export const API_NSI_AP = "static/info/nsiAp";

export const API_AP_LOG_SEARCH = "aplog/searchPageable";
export const API_GET_LOGBOOK_ADMINISTRATIVE_PROCEDURES_FILE = "aplog/printApLog";
export const API_UPDATE_LOGBOOK_ADMINISTRATIVE_PROCEDURES_FILE = "aplog/editApLog";

export const API_GIMS_DEPARTMENT_ALL = "gimsDepartment/all";
export const API_GIMS_DEPARTMENT = "gimsDepartment/id/";
export const API_GIMS_DEPARTMENT_CREATE = "gimsDepartment/postGimsDepartment";
export const API_GIMS_DEPARTMENT_UPDATE = "gimsDepartment/editGimsDepartment/";
export const API_GIMS_SECTION_SEARCH = "gimsSections/search";
export const API_GIMS_SECTION = "gimsSections/id/";
export const API_GIMS_SECTION_CREATE = "gimsSections/postGimsSections";
export const API_GIMS_SECTION_UPDATE = "gimsSections/editGimsSections/";
export const API_ADMINISTRATIVE_DISTRICTS_ALL = "gimsSectionDistricts/all";
export const API_ADMINISTRATIVE_DISTRICTS = "gimsSectionDistricts/id/";
export const API_GET_ALL_COUNTRIES = "directories/countries";
export const API_GET_ALL_TRAINING_ORGANIZATIONS = "directories/trainingOrgs";
export const API_ALL_OBLAST = "directory/getAllOblast";
export const API_ADMINISTRATIVE_DISTRICTS_CREATE = "gimsSectionDistricts/postGimsSectionDistricts";
export const API_ADMINISTRATIVE_DISTRICTS_UPDATE = "gimsSectionDistricts/editGimsSectionDistricts/";
export const API_GIMS_USER_POSITIONS_ALL = "gimsUserPositions/all";
export const API_GIMS_USER_POSITION = "gimsUserPositions/id/";
export const API_GIMS_USER_POSITION_CREATE = "gimsUserPositions/postGimsUserPositions";
export const API_GIMS_USER_POSITION_UPDATE = "gimsUserPositions/editGimsUserPositions/";
export const API_SWIMMING_DIFFICULTY_CATEGORY_ALL = "saCategory/all";
export const API_SWIMMING_DIFFICULTY_CATEGORY = "saCategory/id/";
export const API_SWIMMING_DIFFICULTY_CATEGORY_CREATE = "saCategory/postSaCategory";
export const API_SWIMMING_DIFFICULTY_CATEGORY_UPDATE = "saCategory/editSaCategory/";
export const API_PREPARATION_PROGRAMS_ALL = "trainingProgs/all";
export const API_PREPARATION_PROGRAM = "trainingProgs/id/";
export const API_PREPARATION_PROGRAM_UPDATE = "trainingProgs/editTrainingProgs/";
export const API_PAYMENT_DETAILS_ALL = "gimsInfo/all";
export const API_PAYMENT_DETAILS = "gimsInfo/id/";
export const API_PAYMENT_DETAILS_CREATE = "gimsInfo/postGimsInfo";
export const API_PAYMENT_DETAILS_UPDATE = "gimsInfo/editGimsInfo/";
export const API_SETTLEMENTS = "ateObject/search";
export const API_SETTLEMENT = "ateObject/id/";
export const API_LOCALITY_CATEGORY = "static/info/ateCategory";
export const API_SETTLEMENT_CREATE = "ateObject/postAteObject";
export const API_SETTLEMENT_UPDATE = "ateObject/editAteObject/";
export const API_GET_ALL_IDENTIFICATION_DOCUMENTS = "documentTypes/all";
export const API_GET_IDENTIFICATION_DOCUMENT_BY_ID = "documentTypes/id/";
export const API_UPDATE_IDENTIFICATION_DOCUMENT_BY_ID = "documentTypes/editDocumentTypes/";
export const API_CREATE_IDENTIFICATION_DOCUMENT = "documentTypes/postDocumentTypes";
export const API_GET_ALL_BOAT_TYPES = "boatTypes/all";
export const API_GET_BOAT_TYPE_BY_ID = "boatTypes/id/";
export const API_UPDATE_BOAT_TYPE_BY_ID = "boatTypes/editBoatTypes/";
export const API_CREATE_BOAT_TYPE = "boatTypes/postBoatTypes";
export const API_MED_CONDITIONS_ALL = "docMedConditions/all";
export const API_RANGE_MS_ALL = "boatRegNum/all";
export const API_RANGE_MS_BY_ID = "boatRegNum?id=";
export const API_RANGE_MS_CREATE = "boatRegNum/postBoatRegNum";
export const API_RANGE_MS_UPDATE = "boatRegNum/editBoatRegNum?id=";
export const API_MED_CONDITION = "docMedConditions/id/";
export const API_MED_CONDITION_CREATE = "docMedConditions/postDocMedConditions";
export const API_CREATE_MED_CONDITION_UPDATE = "docMedConditions/editDocMedConditions/";
export const API_TRAINING_DOC_TYPES_ALL = "trainingDocTypes/all";
export const API_TRAINING_EXAM_TYPES_ALL = "trainingExamType";
export const API_TRAINING_DOC_TYPE = "trainingDocTypes/id/";
export const API_TRAINING_DOC_TYPE_CREATE = "trainingDocTypes/postTrainingDocTypes";
export const API_TRAINING_DOC_TYPE_UPDATE = "trainingDocTypes/editTrainingDocTypes/";
export const API_ENGINE_TYPES_ALL = "engineTypes/all";
export const API_ENGINE_TYPE = "engineTypes/id/";
export const API_ENGINE_TYPE_CREATE = "engineTypes/postEngineTypes";
export const API_ENGINE_TYPE_UPDATE = "engineTypes/editEngineTypes/";
export const API_BOAT_BODY_MATERIAL_ALL = "boatBodyMaterial/all";
export const API_BOAT_BODY_MATERIAL = "boatBodyMaterial/id/";
export const API_BOAT_BODY_MATERIAL_CREATE = "boatBodyMaterial/postBoatBodyMaterial";
export const API_BOAT_BODY_MATERIAL_UPDATE = "boatBodyMaterial/editBoatBodyMaterial/";
export const API_GET_ALL_KINDS_BOATS = "boatVid/all";
export const API_GET_KIND_BOAT_BY_ID = "boatVid/id/";
export const API_UPDATE_KIND_BOAT_BY_ID = "boatVid/editBoatVid/";
export const API_CREATE_KIND_BOAT = "boatVid/postBoatVid";
export const API_ACCOUNT_MANAGEMENT_ALL = "gimsUsers/all";
export const API_ACCOUNT_MANAGEMENT_SEARCH = "gimsUsers/search";
export const API_UPDATE_POSITIONS_BY_DEPARTMENT = "gimsUserPositions/by/departament/";
export const API_UPDATE_SECTIONS_BY_DEPARTMENT = "gimsSections/by/departament/";
export const API_ROLES_ALL = "role/actions/getAllRoles";
export const API_ROLES_CREATE = "api/auth/register";
export const API_ACCOUNT_MANAGEMENT = "api/auth/getUserDetail?id=";
export const API_ROLES_EDIT = "api/auth/editRegister?id=";
export const API_USER_BY_ID = "gimsUsers/byId?id=";
export const API_USER_LOGOUT = "api/auth/logout?id=";
export const API_UN_BLOCK_USER = "api/auth/unBlockUser";
export const API_BLOCK_USER = "api/auth/blockUser";
export const API_ROLES_UPDATE = "api/auth/extendPasswordExpiration?id=";
export const API_AVAILABLE_ROLES = "api/auth/allowedRoles?roleId=";
export const API_AUDIT_SECURITY_BY_FIO = "audit/security/getByParamPageable?";
export const API_AUDIT_SECURITY_INACTION_USER = "audit/security/inactionUser?id=";
export const API_GET_DATA_AUDIT_ACTIONS_SYSTEM = "audit/getByParamPageable?";
export const API_USER_HISTORY = "history/audit/";
export const API_GET_DATA_AUDIT_ACTIONS_SYSTEM_100 = "audit/all";
export const API_GET_BILL = "bill";
export const API_GET_QR = "qr";
export const API_GET_INFO_BY_REG_NUM = "minjust";
export const API_GET_INFO_BY_PERS_NUM = "register/";
export const API_GET_INFO_BY_UNP = "minjust?regNum=";
export const API_FOR_AVEST_SIGN = "http://localhost:8085/sign-string";
export const API_GET_INFO_BY_PERS_NUM_WITH_SIGN = "register/";
export const API_GET_BOAT_INFO_BY_VIN = "boatCardApp/search/boat/by/boatVin";
export const API_COUNTRIES = "countries/search";
export const API_CREATE_COUNTRY = "countries/create";
export const API_UPDATE_COUNTRY = "countries/edit/";

export const API_MENU_CHAPTERS_ALL = "static/info/menuChapters";
export const API_CHAPTERS_BY_ROLE = "role/privs/getChapters/";
export const API_CHAPTER_SAVE = "role/privs/saveChapters";
export const API_AVAILABLE_CHAPTERS_BY_CHAPTER_ID = "role/privs/getMenuChaptersByUser/";
export const API_MENU_ACTIONS_ALL = "static/info/menuActions";
export const API_AVAILABLE_ACTIONS_BY_CHAPTER_ID = "role/privs/getActions/";
export const API_ACTION_SAVE = "role/privs/saveActions";
export const API_ACTIONS_BY_CHAPTER_ID = "role/privs/getActionsByChapterId/";
export const API_MENU_STRUCT_BY_USER_ID = "role/privs/getMenuStructByUser/";
export const API_MENU_NAMES = "role/privs/getMenuNames";

export const API_BILL_STATUS = "directories/billStatus";
export const API_PAID_PROC_TYPES = "directory/paidProcType";
export const API_INF_PAYMENT_AP = "static/info/infPaymentAp";
export const API_PATTERN = "patterns/";
export const API_DOWNLOAD_FILE_BOAT_CARD_MODIF = "boatCardModif/print/report/";
export const API_TAKE_OFF_BOAT_CARD_MODIF = "boatCardModif/deregisterEngine/";
export const API_AUDIT_SECURITY_EVENTS = "audit-security-events";
export const API_GIMS_SUB_LEVELS = "gimsSubLevel";

export const API_ORGANIZATIONS = "trainingOrgs/search";
export const API_CREATE_ORGANIZATION = "trainingOrgs/create";
export const API_UPDATE_ORGANIZATION = "trainingOrgs/edit/";
